import { render, staticRenderFns } from "./QuestionTypeIcon.vue?vue&type=template&id=f2826fc6"
import script from "./QuestionTypeIcon.vue?vue&type=script&lang=js"
export * from "./QuestionTypeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2826fc6')) {
      api.createRecord('f2826fc6', component.options)
    } else {
      api.reload('f2826fc6', component.options)
    }
    module.hot.accept("./QuestionTypeIcon.vue?vue&type=template&id=f2826fc6", function () {
      api.rerender('f2826fc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/QuestionTypeIcon.vue"
export default component.exports